/**
 * Core / Mint / Methods: Core
 * ------------------------------------------------------------------------------
 * - Export of core methods for the renderless app.
 * - Mostly handles Pinia actions.
 *
 */
import { mapActions } from 'pinia'

import { useCartStore } from '~stores/cart'
import { useFeatureFlagStore } from '~stores/feature-flags'
import { useLocaleStore } from '~stores/locale'
import { useProductStore } from '~stores/product'
import { useScreenStore } from '~stores/screen'
import { useWishlistStore } from '~stores/wishlist'

/**
 * Export Pinia methods.
 * @return {Object}
 */
export default () => {
  return {

    /**
     * Pinia: Feature Flags.
     */
    ...mapActions(useCartStore, [
      'addItems',
      'clearCart',
      'handleCartUpdate',
      'setCart',
      'updateAttributes',
    ]),

    /**
     * Pinia: Product.
     */
    ...mapActions(useProductStore, [
      'setProduct',
      'queryProduct',
    ]),

    /**
     * Pinia: Feature Flags.
    */
    ...mapActions(useFeatureFlagStore, [
      'setFeatureFlags',
      'toggleFeatureFlag',
    ]),

    /**
     * Pinia: Localisation.
     */
    ...mapActions(useLocaleStore, [
      'setLocale',
      'queryLocale',
    ]),

    /**
     * Pinia: Viewport size.
     */
    ...mapActions(useScreenStore, [
      'handleResize',
      'setScreen',
    ]),

    /**
     * Pinia: Wishlist.
     */
    ...mapActions(useWishlistStore, [
      'handleWishlistUpdate',
      'setWishlist',
    ]),
  }
}